import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated, getUser } from '@/lib/auth';
import { UserRole } from '@pms/shared';

interface AdminRouteProps {
  children: ReactNode;
}

/**
 * Guards the BestAcco platform (super-admin) portal. ONLY super_admin may enter.
 *
 * Hotel/tenant users must get NO signal the portal exists: anyone who isn't a
 * super_admin is hard-redirected to /dashboard (no flash, no error, no leak).
 * Unauthenticated users go to /login.
 */
export function AdminRoute({ children }: AdminRouteProps) {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  const user = getUser();
  if (user?.role !== UserRole.SUPER_ADMIN) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
